
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1762.3 1382.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M424.7 320c151.9 0 283.9 85.2 350.9 210.4H1045V331c-61.7-21.2-106-79.7-106-148.6 0-86.8 70.3-157.1 157.1-157.1 86.7 0 157.1 70.3 157.1 157.1 0 68.9-44.3 127.4-106 148.6v199.3H1729V696c0 78.5-64.2 142.7-142.7 142.7h-155.7v216.4c61.7 21.2 106 79.7 106 148.6 0 86.8-70.3 157.1-157.1 157.1-86.7 0-157.1-70.3-157.1-157.1 0-68.9 44.3-127.4 106-148.6V838.8h-339l-24.3 116.7H743.6c-72.5 97.1-188.3 160-318.8 160C205.1 1115.5 27 937.4 27 717.7S205.1 320 424.7 320zm671.3-74.1c35 0 63.4-28.4 63.4-63.4s-28.4-63.4-63.4-63.4-63.4 28.4-63.4 63.4 28.4 63.4 63.4 63.4zm283.4 894.5c35 0 63.4 28.4 63.4 63.4s-28.4 63.4-63.4 63.4-63.4-28.4-63.4-63.4 28.4-63.4 63.4-63.4zM424.7 567.8c82.8 0 150 67.1 150 150 0 82.8-67.1 150-150 150s-150-67.1-150-150c.1-82.9 67.2-150 150-150z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    